import { render } from "./RingCentralWidget.vue?vue&type=template&id=772e682e&scoped=true"
import script from "./RingCentralWidget.vue?vue&type=script&lang=js"
export * from "./RingCentralWidget.vue?vue&type=script&lang=js"

import "./RingCentralWidget.vue?vue&type=style&index=0&id=772e682e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772e682e"]])

export default __exports__